import { render, staticRenderFns } from "./Comp53t3.vue?vue&type=template&id=2dcaabf6&scoped=true&"
import script from "./Comp53t3.vue?vue&type=script&lang=js&"
export * from "./Comp53t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp53t3.vue?vue&type=style&index=0&id=2dcaabf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaabf6",
  null
  
)

export default component.exports